import React, { useContext } from 'react';
import { UploadContext } from '../contexts/UploadContext';
import PreviewVideo from './PreviewVideo';
import UploadButton from './UploadButton';
import UploadProgress from './UploadProgress';
var Uploader = function () {
    var _a = useContext(UploadContext), fileToUpload = _a.fileToUpload, progress = _a.progress, uploadInProgress = _a.uploadInProgress;
    return (React.createElement("div", { className: "m-auto" }, uploadInProgress ? React.createElement(UploadProgress, null)
        : fileToUpload ? React.createElement(PreviewVideo, null)
            : React.createElement(UploadButton, null)));
};
export default Uploader;
